
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Profile Image */}
            <div className="flex-shrink-0">
              <div className="w-80 h-80 rounded-full overflow-hidden bg-gray-200">
                <img 
                  src="https://static.readdy.ai/image/6f4307f1f4c2fcea149d2ff1a104f958/771e1e5cab3ed15279386c3bdff8bd24.jpeg"
                  alt="Mr. Hidayat Khan - Math and Physics Teacher"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left">
              <h1 className="text-5xl font-bold text-gray-900 mb-4">Mr. Hidayat Khan</h1>
              <p className="text-2xl text-gray-600 mb-8">Maths and Physics Teacher</p>
              
              {/* Tags */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8">
                <span className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">Math Educator</span>
                <span className="px-4 py-2 bg-purple-100 text-purple-800 rounded-full text-sm font-medium">Content Creator</span>
                <span className="px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium">Problem Solver</span>
              </div>

              {/* Description */}
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                My name is Mr. Hidayat Khan and I am a MATHS and PHYSICS Teacher in ALWADI INTERNATIONAL SCHOOL JEDDAH ( SAUDI ARABIA). I 
                hailed from Mumbai, India. I earned a Bachelor's degree in Engineering 
                and Master's degree in Mathematics. I have been teaching for the last 
                26 years, and I'm passionate about making mathematics accessible 
                and enjoyable for everyone.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button className="px-8 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-mail-line mr-2"></i>
                  Contact Me
                </button>
                <button className="px-8 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-links-line mr-2"></i>
                  Connect
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">About Me</h2>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Educational Background</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-graduation-cap-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-medium text-gray-900">Master's in Mathematics</p>
                    <p className="text-gray-600">Advanced mathematical concepts and teaching methodologies</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-graduation-cap-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-medium text-gray-900">Bachelor's in Engineering</p>
                    <p className="text-gray-600">Strong foundation in physics and applied mathematics</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-graduation-cap-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-medium text-gray-900">Diploma in Production Engineering</p>
                    <p className="text-gray-600">Specialized knowledge in manufacturing processes and industrial systems</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Teaching Experience</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-time-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-medium text-gray-900">26 Years of Teaching</p>
                    <p className="text-gray-600">Extensive experience in mathematics and physics education</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-medium text-gray-900">Based in Mumbai, India</p>
                    <p className="text-gray-600">Serving students across various educational levels</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Teaching Philosophy */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Teaching Philosophy</h2>
          
          <div className="bg-white rounded-xl p-8 shadow-sm">
            <blockquote className="text-lg text-gray-700 leading-relaxed text-center italic mb-6">
              "I believe that mathematics is not just about numbers and formulas, but about developing logical thinking and problem-solving skills that students can apply throughout their lives."
            </blockquote>
            
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-blue-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Accessible Learning</h3>
                <p className="text-gray-600 text-sm">Making complex concepts simple and understandable for all students</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-line text-green-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Passionate Teaching</h3>
                <p className="text-gray-600 text-sm">Bringing enthusiasm and energy to every lesson and interaction</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-trophy-line text-purple-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Student Success</h3>
                <p className="text-gray-600 text-sm">Focused on helping every student achieve their mathematical potential</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subjects & Expertise */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Subjects & Expertise</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-blue-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <i className="ri-calculator-line text-blue-600 text-2xl"></i>
                <h3 className="text-xl font-semibold text-gray-900">Mathematics</h3>
              </div>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-blue-600"></i>
                  Algebra & Geometry
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-blue-600"></i>
                  Calculus & Trigonometry
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-blue-600"></i>
                  Statistics & Probability
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-blue-600"></i>
                  Advanced Mathematics
                </li>
              </ul>
            </div>

            <div className="bg-green-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <i className="ri-atom-line text-green-600 text-2xl"></i>
                <h3 className="text-xl font-semibold text-gray-900">Physics</h3>
              </div>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Mechanics & Thermodynamics
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Electricity & Magnetism
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Optics & Waves
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  Modern Physics
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-blue-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Learn?</h2>
          <p className="text-xl text-blue-100 mb-8">
            Join thousands of students who have improved their math and physics skills with personalized guidance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="px-8 py-3 bg-white text-blue-600 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
            <button className="px-8 py-3 border-2 border-white text-white rounded-lg font-medium hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-mail-line mr-2"></i>
              Get in Touch
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
